import { Observable } from "rxjs";
import { CreatePlanRulesTemplateRequest, EditPlanRulesTemplateRequest } from "../domain/requests";
import { PlanRulesTemplate } from "../domain/models/plan-rules-template";

export abstract class PlanRulesTemplateRepository {
  abstract GetPlanRulesTemplateByPlanId(
    request: string
  ): Observable<PlanRulesTemplate>;

   abstract EditPlanRulesTemplate(
    request: EditPlanRulesTemplateRequest
  ): Observable<string>;

   abstract CreatePlanRulesTemplate(
    request: CreatePlanRulesTemplateRequest
  ): Observable<string>;
}